import React, { createContext, useContext, useState, useCallback } from "react";

interface MobileContextType {
  mobileMenuOpen: boolean;
  openMobileMenu: () => void;
  closeMobileMenu: () => void;
  toggleMobileMenu: () => void;
}

const MobileContext = createContext<MobileContextType | undefined>(undefined);

export const MobileProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const openMobileMenu = useCallback(() => setMobileMenuOpen(true), []);
  const closeMobileMenu = useCallback(() => setMobileMenuOpen(false), []);
  const toggleMobileMenu = useCallback(
    () => setMobileMenuOpen((prev) => !prev),
    [],
  );

  return (
    <MobileContext.Provider
      value={{
        mobileMenuOpen,
        openMobileMenu,
        closeMobileMenu,
        toggleMobileMenu,
      }}
    >
      {children}
    </MobileContext.Provider>
  );
};

export const useMobileMenu = () => {
  const context = useContext(MobileContext);
  if (!context) {
    throw new Error("useMobileMenu must be used within MobileProvider");
  }
  return context;
};
